import React from 'react'

import { Button, Flex, Header, Paper, styled, Text } from '@driftt/dds'

type TableWrapperProps = {
  title: string
  description?: string
  children: React.ReactNode
  onClickAction?: () => void
  actionText?: string
  isLoadingAction?: boolean
  rootProps?: React.HTMLAttributes<HTMLDivElement>
}

export const StyledHeader = styled(Flex, {
  paddingTop: '$3',
  paddingLeft: '$3',
  paddingRight: '$3',
  paddingBottom: '$1',
})

export const TableWrapper = ({
  title,
  description,
  children,
  onClickAction,
  actionText = 'Export CSV',
  isLoadingAction = false,
  rootProps = {},
}: TableWrapperProps) => {
  return (
    <Paper
      elevation={2}
      as={Flex}
      direction="column"
      alignItems={'stretch'}
      rootProps={rootProps}
    >
      <StyledHeader justifyContent="space-between">
        <Flex direction="column" gap={'half'}>
          <Header variant={'h3'}>{title}</Header>
          {description ? <Text variant={'metadata'}>{description}</Text> : null}
        </Flex>
        {onClickAction && (
          <Button
            variant={'secondary'}
            onClick={onClickAction}
            loading={isLoadingAction}
          >
            {actionText}
          </Button>
        )}
      </StyledHeader>
      {children}
    </Paper>
  )
}
